
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM4.873 4.873a7.25 7.25 0 1110.254 10.253A7.25 7.25 0 014.873 4.873zM8.4 6.583a.75.75 0 01.75.75v5.334a.75.75 0 01-1.5 0V7.333a.75.75 0 01.75-.75zm3.2 0a.75.75 0 01.75.75v5.334a.75.75 0 01-1.5 0V7.333a.75.75 0 01.75-.75z"}})])
          )
        }
      }
    